/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-neutral': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM7.187 6.875a1.563 1.563 0 100 3.125 1.563 1.563 0 000-3.125zm5.625 0a1.563 1.563 0 100 3.125 1.563 1.563 0 000-3.125zM6.25 12.5h7.5v1.25h-7.5V12.5z"/>'
  }
})
